import PropTypes from "prop-types";
import React from "react";

import styled from "styled-components/macro";

import { FnrRadioButtonOption } from "UI/FnrRadioButtonOption";

RadioOption.propTypes = {
  selected: PropTypes.bool,
  id: PropTypes.number,
  label: PropTypes.string,
  onClick: PropTypes.func,
  loading: PropTypes.bool,
};

export default function RadioOption({
  selected,
  id,
  label,
  onClick,
  loading,
  disabled,
  children,
}) {
  // TODO: This should get the value of whatever disabled flag we are using
  let disabledFlag = false;

  let isDisabled =
    disabled === undefined || disabled === null ? disabledFlag : disabled;

  return (
    <Wrapper disabled={isDisabled}>
      <FnrRadioButtonOption
        label={label}
        isActive={selected}
        onClick={() => {
          if (selected) return;

          if (id) {
            onClick(id);
          } else {
            onClick();
          }
        }}
        style={{ margin: 0 }}
        fontSize={16}
        marginRight={15}
        isLoading={loading}
        loadingColor="blue"
        iconColor="#016099"
        activeCircle="dotCircle"
      />

      <Content>{children}</Content>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  pointer-events: ${({ disabled }) => (disabled ? "none" : "auto")};
  opacity: ${({ disabled }) => (disabled ? 0.65 : 1)};
`;
const Content = styled.div`
  /* outline: 1px solid red; */
  margin-left: 36px;
`;
